// extracted by mini-css-extract-plugin
export default {"Home":"Styles_Home__qDaRf"};